const toolbar = {
  options: [
    "blockType",
    "fontSize",
    "textAlign",
    "colorPicker",
    "inline",
    "list",
    "link",
    // "embedded",
    //"emoji",
    //"image",
  ],
  blockType: {
    inDropdown: true,
    options: ["H2", "H3", "Normal"],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined
  },
  inline: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ["bold", "italic", "underline"]
  },
  fontSize: {
    options: [12, 14, 16, 18, 20, 22, 24],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined
  },
  link: {
    options: ["link", "unlink"],
    showOpenOptionOnHover: false,
  },
  list: {
    inDropdown: false,
    options: ["ordered", "unordered"]
  },

  textAlign: {
    inDropdown: false,
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
    options: ["left", "center"]},

  
  colorPicker: {
    className: undefined,
    component: undefined,
    popupClassName: undefined,
    colors: [
       'rgb(0,0,0)',       // Black
      'rgb(255,255,255)', // White
      'rgb(255,0,0)',     // Red
      'rgb(0,255,0)',     // Green
      'rgb(0,0,255)',     // Blue
      'rgb(255,255,0)',   // Yellow
      'rgb(255,0,255)',   // Magenta
      'rgb(0,255,255)',   // Cyan
    ],
  },
  /*
  emoji: {
    className: undefined,
    component: undefined,
    popupClassName: undefined,
  }
  */

};

export default toolbar;